(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/products/assets/javascripts/products.js') >= 0) return;  svs.modules.push('/components/utils/products/assets/javascripts/products.js'); 
'use strict';

var svs = svs || {};

var products = {
  1: {
    ITSName: 'Stryk',
    prodname: 'stryktipset'
  },
  2: {
    ITSName: 'Ita',
    prodname: 'europatipset'
  },
  6: {
    ITSName: 'Matchen',
    prodname: 'matchen'
  },
  7: {
    ITSNAme: 'Bomben',
    prodname: 'bomben'
  },
  8: {
    ITSName: 'Mal',
    prodname: 'maltipset'
  },
  9: {
    ITSName: 'Keno',
    prodname: 'keno'
  },
  10: {
    ITSName: 'Lorlotto',
    prodname: 'lorlotto'
  },
  11: {
    ITSName: 'Onslotto',
    prodname: 'onslotto'
  },
  14: {
    ITSName: 'Viking',
    prodname: 'vikinglotto'
  },
  22: {
    ITSName: 'Ox',
    prodname: 'oddset'
  },
  23: {
    ITSName: 'T8stryk',
    prodname: 'topptipset'
  },
  24: {
    ITSName: 'T8extra',
    prodname: 'topptipset'
  },
  25: {
    ITSName: 'T8',
    prodname: 'topptipset'
  },
  26: {
    ITSName: 'Bombenx',
    prodname: 'bomben'
  },
  28: {
    ITSName: 'Powerplay',
    prodname: 'powerplay'
  },
  29: {
    ITSName: 'Elotto',
    prodname: 'eurojackpot'
  }, 
  45: {
    ITSName: 'TMIX',
    prodname: 'challenge'
  } 
};

svs.utils = svs.utils || {};
svs.utils.products = svs.utils.products || {};

svs.utils.products.getProdName = function(id) {
  return products[id] ? products[id].prodname : undefined;
};

svs.utils.products.getProdNameByITSName = function(ITSName) {
  if (typeof ITSName !== 'string') {
    throw new Error('First argument must be of type string');
  }

  for (var id in products) {
    if (products[id]) {
      if (
        products[id].ITSName &&
        typeof products[id].ITSName === 'string' &&
        products[id].ITSName.toLowerCase() === ITSName.toLowerCase()
      ) {
        return products[id].prodname;
      }
    }
  }

  throw new Error("Couldn't find product name from ITS name: " + ITSName);
};

if (typeof exports === 'object') {
  module.exports = svs.utils.products;
}


 })(window);